<div class="container">
  <app-navbar></app-navbar>
  <app-shared-loading *ngIf="loading"></app-shared-loading>
  <div id="ticketDiv">
    <div class="voucherBox">
      <p class="topMsg" *ngIf="infoPayment">{{ 'payment-Receipt-Title' | translation | async }}</p>
      <img
        src="assets/images/payvalida.svg"
        alt="Payvalida, pasarela de pagos"
        title="Payvalida, pasarela de pagos"
        class="voucherLogo"
      />
      <div class="retryConfirmation" *ngIf="(!infoPayment || pend) && tryLeftConsultTicket > 1 && !loading">
        Estamos procesando la información de tu pago, por favor espera <b>{{ timeIntervalToRequestAgain }}</b> segundos.
      </div>

      <div class="retryConfirmation" *ngIf="(!infoPayment || pend) && tryLeftConsultTicket < 2 && !loading">
        La transacción se encuentra en validación, puede hacer seguimiento con el CUS comunicándose a través de nuestros
        canales de atención al cliente.
      </div>

      <div class="leftInfoVoucher">
        <ng-container *ngIf="pColTransaction != null ; else standardPsePayment">
          <h1 *ngIf="response != null" [ngClass]="{ approved: approve, failed: fail, pended: pend }">
            {{'html-Pay-Title' | translation | async}} {{ response }}
          </h1>
          <h2>{{ transaction.MERCHANT_NAME }}</h2>
          <p>{{ 'html-Date-Title' | translation | async }}: {{ pColTransaction?.date }}</p>
          <p class="reference">
            <b>{{ 'reference-label' | translation | async}}:</b> {{ pColTransaction?.reference }}
          </p>
          <div class="pColInfo">
            <p *ngIf="!pColTransaction?.remainingAmount">{{ 'pcol-payment-title' | translation | async }}</p>
            <p *ngIf="pColTransaction?.remainingAmount">{{ 'split-pcol-payment-title' | translation | async }}</p>
            <p>{{'pcol-points-label' | translation | async}}: {{ transaction.ORDER_CURRENCY }} {{ pColTransaction?.pcolRedeemed | number : '1.2-2' }}</p>
            <p *ngIf="pColTransaction?.pcolRedeemed">{{ 'money-label' | translation | async }}: {{ transaction.ORDER_CURRENCY }} {{ pColTransaction?.remainingAmount | number : '1.2-2' }}</p>
          </div>
          <div class="flexBox">
            <div class="column">
              <b>{{ 'total-label' | translation | async }}:</b>
            </div>
            <div class="column">
              <b>{{ pColTransaction.totalAmount | number : '1.2-2' }}  {{ transaction.ORDER_CURRENCY }}</b>
            </div>
          </div>
        </ng-container>

        <ng-template #standardPsePayment>
          <h1 *ngIf="response != null" [ngClass]="{ approved: approve, failed: fail, pended: pend }">
            Pago {{ response }}
          </h1>
          <h2>{{ transaction.MERCHANT_NAME }}</h2>
          <div class="leftInfoVoucher">
            <p *ngIf="this.pseReturnTransaction?.TRANSACTION_DATE">
              Fecha: {{ this.pseReturnTransaction?.TRANSACTION_DATE }}</p>
            <p class="reference" *ngIf="transaction?.ORDER_REFERENCE != null">
              <b>Referencia:</b> {{ transaction?.ORDER_REFERENCE }}
            </p>
            <br/>
            <p *ngIf="this.pseReturnTransaction?.BANK">Banco: {{ this.pseReturnTransaction?.BANK }}</p>
            <p *ngIf="this.pseReturnTransaction?.NIT">NIT del comercio: {{ this.pseReturnTransaction?.NIT }}</p>
            <p *ngIf="this.pseReturnTransaction?.TRAZABILITY_CODE">
              CUS: {{ this.pseReturnTransaction?.TRAZABILITY_CODE }}</p>
            <p *ngIf="this.pseReturnTransaction?.TICKET_ID">Ticket ID: {{ this.pseReturnTransaction?.TICKET_ID }}</p>
            <p *ngIf="this.order?.OrderID">Orden: {{ order.OrderID }}</p>
            <p *ngIf="this.order?.OrderDesc">Descripción: {{ order.OrderDesc }}</p>
            <br/>
            <div class="flexBox">
              <div class="column">
                <b>Total:</b>
              </div>
              <div class="column">
                <b>{{ transaction.ORDER_AMOUT | number : '1.2-2' }}  {{ transaction.ORDER_CURRENCY }}</b>
              </div>
            </div>
            <div *ngIf="(!infoPayment || pend) && tryLeftConsultTicket < 2 && !loading">
              <br/>
              <p class="longEmail">Email: {{ this.transaction.MERCHANT_EMAIL }}</p>
              <p>Cel: {{ this.transaction.MERCHANT_CEL }}</p>
            </div>
          </div>
        </ng-template>

      </div>
      <app-generic-button *ngIf="fail" text="Reintentar Pago" (click)="retryPayment()"></app-generic-button>
      <app-buttons-bar
        *ngIf="infoPayment"
        [valid]="true"
        (PR)="print()"
      ></app-buttons-bar>
      <p class="voucherFooter" *ngIf="infoPayment">{{ 'no-Print-Receipt' | translation | async }}</p>
    </div>
  </div>
</div>
<app-footer [isVoucher]="true" [startLoading]="startDelay"></app-footer>
